import { render, staticRenderFns } from "./ErrorNote.vue?vue&type=template&id=152611d5&scoped=true"
import script from "./ErrorNote.vue?vue&type=script&lang=js"
export * from "./ErrorNote.vue?vue&type=script&lang=js"
import style0 from "./ErrorNote.vue?vue&type=style&index=0&id=152611d5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152611d5",
  null
  
)

export default component.exports